<template>
  <!-- <div class="row"> -->
  <div>
    <!-- <app-overlay-loader v-if="preloader" /> -->

    <!-- <div class="text-right mr-5 mb-5">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="stiteList"
          >
            {{ $t("site_list") }}
          </button>
        </div> -->
    <div v-for="(s, sIndex) in site" :key="sIndex">
      <div style="box-shadow: var(--sidebar-box-shadow)">
        <div class="card-body">
          <div class="form-group row" style="align-items: center">
            <div class="col-sm-8">
              <h5>{{ $t("create_site") }}</h5>
            </div>
            <div class="col-sm-4">
              <div style="text-align: end">
                <!-- <button
                  class="btn btn-primary btn-sm"
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Add Task"
                  v-on:click="addNewTask(sIndex)"
                  name="plus-square"
                >
                  Add Task
                </button> -->
                <button
                v-if="sIndex != 0 "
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Remove"
                  class="btn btn-danger btn-sm"
                  name="minus-square"
                  v-on:click="popSite(sIndex)"
                >
                  Remove Site
                </button>
                <!-- <button
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Add Site"
                  class="btn btn-dark btn-sm"
                  v-on:click="addNewSite"
                  name="plus-square"
                >
                  Add Site
                </button> -->
              </div>
            </div>
          </div>
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
          >
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="text"
                placeholder="Enter Title"
                v-model="s.title"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="" class="col-sm-3 mb-0">
                {{ $t("description") }}
              </label>
              <app-input
                class="col-sm-9"
                type="textarea"
                placeholder="Enter Description"
                v-model="s.description"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="" class="col-sm-3 mb-0">
                {{ $t("assignment_structure") }}
              </label>
              <app-input
                class="col-sm-9"
                type="textarea"
                placeholder="Enter Assignment Structure"
                v-model="s.assignment_structure"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="" class="col-sm-3 mb-0">
                {{ $t("site_address") }}
              </label>
              <app-input
                class="col-sm-9"
                type="textarea"
                placeholder="Enter Site Address"
                v-model="s.site_address"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="" class="col-sm-3 mb-0">
                {{ $t("site_info") }}
              </label>
              <app-input
                class="col-sm-9"
                type="textarea"
                placeholder="Enter Site Information"
                v-model="s.site_info"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("start_time") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="time"
                placeholder="Select Start Time"
                v-model="s.start_time"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("end_time") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="time"
                placeholder="Select End Time"
                v-model="s.end_time"
                :required="true"
              />
            </div>
          </form>
        </div>
      </div>
      <!-- <div
        style="box-shadow: var(--sidebar-box-shadow); margin-top: 10px"
        v-for="(t, index) in s.task"
        :key="index"
      >
        <div class="card-body">
          <div class="form-group row">
            <div class="col-sm-8 col-12">
              <h5>{{ $t("store_tasks") }}</h5>
            </div>
            <div class="col-sm-4 col-12">
              <div style="text-align: end">
                <button
                  class="btn btn-danger"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Remove"
                  type="button"
                  v-on:click="popTask(index)"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
          >
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="text"
                v-model="t.title"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("description") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="textarea"
                v-model="t.description"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
            
                <label class="col-sm-2 mb-0">{{ $t("start_date") }}</label>
                <app-input
                  type="date"
                  class="col-sm-4"
                  v-model="t.start_date"
                  :placeholder="$t('select_valid_date')"
                />
  
                <label class="col-sm-2 mb-0">{{ $t("due_date") }}</label>
                <app-input
                  type="date"
                  class="col-sm-4"
                  v-model="t.due_date"
                  :placeholder="$t('select_valid_date')"
                />
            </div>
            <div class="form-group row align-items-center">
              <label class="col-sm-3 mb-0">{{ $t("priority") }}</label>
              <app-input
                type="radio"
                class="col-sm-9"
                :list="list"
                v-model="t.priority"
              />
          </div>
          </form>
        </div>
      </div> -->
    </div>
    <div class="action-buttons" style="text-align: end">
      <div class="card-body">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="storeSite"
        >
          {{ $t("submit") }}
         </button>
        <!--<button type="submit" class="btn btn-secondary" @click.prevent="clear">
          {{ $t("clear") }}
        </button> -->
      </div>
    </div>
    <!-- <div class="card-body">
          <form
            ref="form"
            data-url="/crud"
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("assigned_supplier") }}</label>
                  <table class="table">
                    <tr v-if="notNull == true">
                      <td>{{ assignSupplier.bid.company.company_name }}</td>
                      <td>{{ assignSupplier.bid.company.company_email }}</td>
                      <td>{{ assignSupplier.bid.company.company_phone }}</td>
                      <td>{{ assignSupplier.bid.bid_amount }}</td>
                      <td>
                        <button class="btn btn-primary btn-sm">view</button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <label>{{ $t("bid_list") }}</label>
                <table class="table">
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Bid Amount</th>
                    <th>Action</th>
                  </tr>
                  <tr v-for="(bid, index) in bids" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ bid.company_name }}</td>
                    <td>{{ bid.company_email }}</td>
                    <td>{{ bid.company_phone }}</td>
                    <td>{{ bid.pivot.bid_amount }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="assignedSupplier(bid.pivot.id)"
                      >
                        Assign
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </form>
        </div> -->
  </div>
  <!-- </div> -->
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_SITE_STORE,
  COMPANY_JOB_STORE,
  COMPANY_JOB_GET,
  JOB_BID_LISTING,
  JOB_BID_ACCEPT,
  JOB_CATEGORY_NAME,
  JOB_CHECK_ACCEPTED_SUPPLIER,
} from "../../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      job: {},
      site: [],
      task: [],
      bids: {},
      acceptedBid: {},
      assignSupplier: [],
      //   seen: false,
      //   sitecreate: false,
      //   notNull: false,
      list: [
        {
          id: "High",
          value: "High",
        },
        {
          id: "Medium",
          value: "Medium",
        },
        {
          id: "Low",
          value: "Low",
        },
      ],
    };
  },
  props: ["getJob", "siteid",'siteType','jobid'],
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      // this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    addNewSite() {
      this.addSite();
    },
    popSite(index) {
      this.site.splice(index, 1);
    },
    popTask(index) {
      this.task.splice(index, 1);
    },
    addNewTask(id) {
      this.addTask(id);
    },
    storeSite() {
      
      // this.site.type = this.siteType;
      axiosPost(COMPANY_JOB_SITE_STORE, this.site)
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.site = [];
          //   this.seen = false;
          //   
          this.addSite();
          this.getJob(this.jobid);
          localStorage.setItem('siteId', res.data.siteId);
        })
        .catch((error) => {
          
          this.$toastr.e(error);
        });
    },
    addSite() {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      
      // let id = split[6].split("?")[0];
      let id = this.jobid;
      this.site.push({
        job_id: id,
        title: "",
        description: "",
        start_time: "",
        end_time: "",
        site_address: "",
        site_info: "",
        task: [],
        type: this.siteType,
      });
    },
    addTask(id) {
      this.site[id].task.push({
        title: "",
        description: "",
        start_date: "",
        due_date: "",
        priority: "",
      });
    },
    // getCustomerJob() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   //   
    //   axiosGet(COMPANY_JOB_GET + "/" + id)
    //     .then((response) => {
    //       //   
    //       this.job = response.data;
    //       //   this.titleinvoice = response.data.company_name;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },

    // getBids() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   axiosGet(JOB_BID_LISTING + "/" + id)
    //     .then((res) => {
    //       this.bids = res.data;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    // assignedSupplier(id) {
    //   axiosGet(JOB_BID_ACCEPT + "/" + id)
    //     .then((res) => {
    //       this.assignSupplier = res.data;
    //       this.notNull = true;
    //       this.sitecreate = true;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },

    // checkAssignedSupplier() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   axiosGet(JOB_CHECK_ACCEPTED_SUPPLIER + "/" + id)
    //     .then((res) => {
    //       this.assignSupplier = res.data;
    //       this.notNull = true;
    //       this.sitecreate = true;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    // assignedSupplier()
    // {
    //     // alert(id);
    //     this.assignSupplier = {
    //         'id':'1',
    //         'name':'Test'
    //     }
    //     this.sitecreate = true;
    //     // this.seen = true;
    //     // this.addSite();
    //     
    // },
    // getCategoryName()
    // {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   axiosGet(JOB_CATEGORY_NAME + "/" + id)
    //     .then((res) => {
    //       
    //       this.job.category = res.data;

    //       
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    stiteList() {
      this.seen = true;
      this.addSite();
    },
  },
  mounted() {
    this.addSite();
    // this.getBids();
    // this.getCustomerJob();
    // this.checkAssignedSupplier();
    // this.getCategoryName();
  },
};
</script>
